export const BLOCK_TYPES = {
  unStyled: 'unstyled',
  headerTwo: 'header-two',
  headerThree: 'header-three',
  unorderedListItem: 'unordered-list-item',
  orderedListItem: 'ordered-list-item',
};

export const DEFAULT_STYLES = ['bold', 'italic', 'nospacing', 'highlighted'];

export const SEPARATE_NEXT = 'separate-next';

export const SEPARATE_NEXT_PHRASE = 'separate-next-phrase';

export const LINE_BREAKS = ['\n\n', '\n'];

export const BLOCK_LENGTH_LIMIT = 35;
